/**
 * Settings landing — redirects to the first built section.
 *
 * The settings shell uses a vertical rail with all 16 sections; the bare
 * `/settings` URL has no content of its own, so we bounce to
 * `/settings/profile` — the first item in the first ("Account") group of
 * the settings rail (`features/settings/lib/sections.ts`), so the landing
 * matches where the rail's selection starts.
 *
 * Using TanStack's `beforeLoad` so the redirect happens during route
 * resolution, not after a render — no flash of an empty shell.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(workspace)/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/profile" });
  },
});
